<template>
    <div class="pp-date-picker">
        <div v-for="(item, index) in columns" :key="index"
            class="pp-date-time-picker__column"
            :data-time="item"
            @scroll="scroll">
            <div v-if="validate(item, option)"
                v-for="(option, index2) in options[item]" :key="index2" 
                class="pp-date-time-picker__option">
                {{option}}
            </div>
        </div>
    </div>
</template>

<script>
import * as config from './config.js'
import pTime from './time-item.vue'
export default {
    mixins: [pTime],
    data: function() {
        return {
            columns: ['years', 'months', 'dates'],
            options: {
                years: config.Years,
                months: config.Months,
                dates: config.Dates,
            },
            currentValue: {
                years: config.Years[0], months: config.Months[0], dates: config.Dates[0],
            },
        };
    },
    computed: {
        pickerDate: function() {
            return this.DateTimePicker.dateTime;
        },
    },
    methods: {
        validate: function(column, value) {
            if(column === 'dates') {
                let year = Number(this.pickerDate.years);
                let month = Number(this.pickerDate.months);

                if([1,3,5,7,8,10,12].includes(month)) {
                    return value <= 31;
                }
                else if(month === 2) {
                    return this.isLeapYear(year) 
                        ? value <= 29 
                        : value <= 28;
                }
                else {
                    return value <= 30;
                }
            }
            else {
                return true;
            }
        },

        isLeapYear: function(year) {
            return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
        },
    },
}
</script>

<style>

</style>
